import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Button } from '@mui/material';


const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutPopup({
      postLogoutRedirectUri: window.location.origin,
    });
  };

  return (
    <Button
      variant="outlined"
      color="inherit"
      onClick={handleLogout}
      className="sign-out-btn"
      size="small"
      sx={{ marginLeft: { xs: 0, sm: '0.5rem' }, textTransform: 'none' }}
    >
      Sign Out
    </Button>
  );
};


export default SignOutButton;